import React from "react";

/**
 * Fixed-position "Powered by Beyond Measure" badge in the bottom-right corner.
 * Visible on every page (including login). Theme-aware via CSS custom
 * properties — text uses --atech-text-dim so it's readable on both
 * dark-grey and light surfaces. The icon is a transparent PNG so the
 * black background only appears where the artwork already has it.
 */
export default function PoweredByBadge() {
  return (
    <a
      href="https://www.beyondmeasure.global"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-3 right-3 sm:bottom-4 sm:right-4 z-[60]
                 inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full
                 bg-[color:var(--atech-surface)]/70 backdrop-blur-sm
                 border border-[color:var(--atech-border)]
                 text-[10px] uppercase tracking-[0.16em]
                 text-[color:var(--atech-text-muted)]
                 hover:text-[color:var(--atech-text)]
                 hover:border-[color:var(--atech-border-strong)]
                 transition-colors shadow-sm"
      data-testid="powered-by-beyond-measure"
      aria-label="Powered by Beyond Measure — opens beyondmeasure.global in a new tab"
    >
      <span className="hidden sm:inline">Powered by</span>
      <img
        src="/beyond-measure-icon.png"
        alt="Beyond Measure"
        className="h-3.5 w-3.5 object-contain rounded-full bg-black"
        loading="lazy"
        width="14"
        height="14"
      />
      <span className="font-medium text-[color:var(--atech-text-dim)] normal-case tracking-normal text-[11px]">
        Beyond&nbsp;Measure
      </span>
    </a>
  );
}
